export enum KidTypeE {
  Junior = 'Junior',
  AllStars = 'All-Stars',
  Other = 'Other',
}
export type KidTypeT = `${KidTypeE}`;
export function getKidType(age: number): KidTypeT {
  if (age >= 4 && age <= 11) {
    return KidTypeE.Junior;
  }
  if (age >= 12 && age <= 17) {
    return KidTypeE.AllStars;
  }
  return KidTypeE.Other;
}
export function calculateAge(birthDate: Date): number {
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}
